import React from 'react';
import {
  CheckIcon,
  TrashBinIcon,
  AttentionTriangleIcon,
} from '@rsos/assets/icons';
import Loader from '@rsos/components/capstone/Loader';
import { Box, Text } from '@rsos/components/capstone/base';
import EmptyInbound from './EmptyInbound';
import {
  InboundTRow,
  InboundTHead,
  InboundTData,
  InboundTable,
  Container,
  TimeStampContainer,
  ViewOrEdit,
} from './Inbound.styles';
import { IconWrapper } from './Main.styles';

const customUnixTimestamp = dateTime => {
  const date = new Date(dateTime);
  const currentTime = date.toLocaleTimeString('en-US');
  const timeZone = date
    .toLocaleTimeString('en-US', { timeZoneName: 'short' })
    .split(' ')[2];
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}.${day}.${year}, ${currentTime} ${timeZone}`;
};

const InboundTableContainer = ({
  toggleDeleteCredentialModal,
  isFetching,
  credentials,
  fetchCredential,
  setSelectedDeleteCredential,
  toggleAddCredentialModal,
}) => {
  const isEmpty = !credentials || credentials?.length === 0;

  const handleDeleteClicked = cred => {
    setSelectedDeleteCredential(cred);
    toggleDeleteCredentialModal();
  };

  return (
    <Container position={'relative'}>
      <InboundTable>
        {isFetching ? (
          <Box
            width={'100%'}
            height={'100%'}
            position={'absolute'}
            justify={'center'}
          >
            <Loader height={'100% !important'} fluid />
          </Box>
        ) : isEmpty ? (
          <>
            <InboundTHead></InboundTHead>
            <EmptyInbound toggleAddCredentialModal={toggleAddCredentialModal} />
          </>
        ) : (
          <>
            <InboundTHead>
              <InboundTData indent>CREDENTIAL NAME</InboundTData>
              <InboundTData>SOURCE</InboundTData>
              <InboundTData>TIMESTAMP</InboundTData>
            </InboundTHead>
            {credentials &&
              credentials.map((cred, i) => {
                return (
                  <InboundTRow key={cred.internal_id} background={i % 2}>
                    <InboundTData color="primaryText">
                      {cred.valid ? (
                        <IconWrapper color={'panePrimaryText'} px={2}>
                          <CheckIcon />
                        </IconWrapper>
                      ) : (
                        <IconWrapper color={'lightDanger'} px={2}>
                          <AttentionTriangleIcon height={13} width={24} />
                        </IconWrapper>
                      )}
                      <Text ellipsis maxWidth={'45%'} color="primaryText">
                        {cred.credential_name}
                        {!cred.valid && (
                          <Text
                            color={'lightDanger'}
                            size="xsmall"
                            fontWeight="regular"
                            ellipsis
                          >
                            Credentials are invalid, please review
                          </Text>
                        )}
                      </Text>
                    </InboundTData>
                    <InboundTData fontWeight="400">
                      {cred.data_source}
                    </InboundTData>
                    <InboundTData fontWeight="400">
                      <TimeStampContainer>
                        <Text ellipsis maxWidth={'45%'}>
                          {customUnixTimestamp(cred.created_at)}
                        </Text>

                        <Box
                          minWidth={'45%'}
                          horizontal
                          noShrink
                          justify="flex-end"
                          height={'20px'}
                        >
                          <IconWrapper
                            border={'1px solid '}
                            borderColor={'heavyLineOutline'}
                            borderRadius={'5px'}
                            clickable
                            onClick={() => handleDeleteClicked(cred)}
                          >
                            <TrashBinIcon width={16} height={16} />
                          </IconWrapper>
                          <ViewOrEdit
                            border={'1px solid '}
                            borderColor={'heavyLineOutline'}
                            borderRadius={'5px'}
                            px={'12px'}
                            ml={2}
                            onClick={() => fetchCredential(cred)}
                          >
                            <Text size="xsmall">View or Edit</Text>
                          </ViewOrEdit>
                        </Box>
                      </TimeStampContainer>
                    </InboundTData>
                  </InboundTRow>
                );
              })}
          </>
        )}
      </InboundTable>
    </Container>
  );
};

export default InboundTableContainer;
